import { Component, Inject, HostListener } from '@angular/core';
import { PermissionsService } from '../../services/permissions/permissions.service';

@Component({
    selector: 'profile',
    templateUrl: './profile.component.html',
    styleUrls: ['./profile.component.css'],
})

export class ProfileComponent {
    constructor(public permissions: PermissionsService) {
    }

    showSidebar: boolean = true;
    showButton: boolean = false;

    buttonClick() { 
        this.showSidebar = !this.showSidebar;
    }

    @HostListener('window:resize', ['$event']) onResize(event) {
        let newWidth = event.target.innerWidth;
        if (newWidth < 768) {
            this.showSidebar = false;
            this.showButton = true;
        }
        else {
            this.showSidebar = true;
            this.showButton = false;
        }
    }

    ngOnInit() {
    }
    
}
